import { createContext, PropsWithChildren, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { NotFound } from "@/components/pages";
import { useGetVehicleQuery } from "@/redux/apis/vehicle/vehicleApi";
import { Vehicle } from "@/redux/slices/vehicle/types";

type Steps = "access-manager" | "history-logs" | "registration-renewal" | "operator-notes" | "vehicle-category-side-panel" | "vehicle-category-modal";

interface IViewVehicleContext {
  vehicle: Vehicle;
  activeModal?: Steps;
  setActiveModal: (modal?: Steps) => void;
}
const ViewVehicleContext = createContext<IViewVehicleContext | null>(null);

export const ViewVehicleProvider = ({ children }: PropsWithChildren) => {
  const { vehicleId } = useParams<{ vehicleId: string }>();
  const { data: vehicle, isFetching, isError } = useGetVehicleQuery(vehicleId ?? "", { skip: !vehicleId });
  const [activeModal, setActiveModal] = useState<IViewVehicleContext["activeModal"]>(undefined);

  if (isError) return <NotFound noBackground noHeader />;
  if (isFetching || !vehicle) return <Loading />;

  return <ViewVehicleContext.Provider value={{ vehicle, activeModal, setActiveModal }}>{children}</ViewVehicleContext.Provider>;
};

export const useViewVehicleContext = () => {
  const context = useContext(ViewVehicleContext);
  if (!context) {
    throw new Error("useViewVehicleContext must be used within an ViewVehicleProvider");
  }
  return context;
};
